import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../styles/PageHeader.css";

function PageHeader(props: { image: string; title: string }) {
  const { t } = useTranslation();

  return (
    <div
      className="page-header-wrap"
      style={{ backgroundImage: `url("${props.image}")` }}
    >
      <div className="page-header-overlay" />
      
      <div className="container">
        <div className="page-header-content">
          <h1 className="page-header-title">{props.title}</h1>
          
          <nav className="page-header-breadcrumb">
            <Link to="/">{t("Home")}</Link>
            <span className="breadcrumb-sep" />
            <span className="breadcrumb-current">{props.title}</span>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default PageHeader;

